import React from 'react';

import systems from '../../../../../images/systems.svg';

const SystemsIconComponent = ({ height = '14px', width = height, altText = 'icon', selected }) => {
  return <img src={systems} alt={altText} style={{ width, height }} />;
};

export default SystemsIconComponent;
